const setGraphData_graphView = payload => {
  return {
    type: "setGraphData_graphView",
    payload
  };
};
export default setGraphData_graphView;
